const styles = (theme) => ({
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  cardSubText: {
    fontWeight: 500,
    fontSize: "20px",

    mb: 0.4,
    "@media (max-width: 600px)": {
      fontSize: "16px",
      mb: 0.1,
    },
  },
  containerIconCard: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "30px",
    height: "30px",
    borderRadius: "5px",
  },
  paperContainer: {
    width: "100%",
    display: "flex",
    p: 2,
    borderRadius: "16px",
    flexDirection: "column",
    gap: 2,
    position: "relative",
  },
  boxInfoTooltip: { display: "flex", alignItems: "center", gap: 1 },
  containerTooltip: {
    bgcolor: theme.palette.paletteCharts.lineCharts,
    padding: "8px",
    borderRadius: "8px",
  },
  boxTitle: {
    display: "flex",
    gap: 1,
    alignItems: "center",
    marginBottom: "10px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  historyButton: {
    color: theme.palette.text.secondary,
  },
  icon: {
    height: 22,
    width: 22,
    color: theme.palette.white.main,
  },
  boxGraph: { width: "100%", height: 110 },
  boxLoading: {
    position: "relative",
    overflow: "hidden",
    borderRadius: "16px",
    height: 30,
  },
  datagridPaper: {
    height: 150,
    borderRadius: "16px",
    overflowX: "auto",
    mt: 3,
  },
  cardsGrid: {
    width: "100%",
    display: "grid",
    gap: 1,
  },
  emptyVisibilidade: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
    padding: "24px",
    borderRadius: "16px",
    backgroundColor: theme.palette.background.paper,
  },
  emptyVisibilidadeText: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
    textAlign: "center",
  },
  secoesContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  divisorSecoes: {
    borderColor: theme.palette.divider,
  },
  accordionSecao: {
    width: "100%",
    borderRadius: "16px",

    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    "&:before": {
      display: "none",
    },
    "&.Mui-expanded": {
      margin: 0,
    },
    "&:first-of-type": {
      borderRadius: "16px",
    },
    "&:last-of-type": {
      borderRadius: "16px",
    },
  },
  accordionSummary: {
    "&.Mui-expanded": {
      minHeight: "48px",
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "12px 0",
    },
  },
  accordionHeaderRow: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    pr: 1,
  },
  accordionTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  accordionIcon: {
    color: theme.palette.text.secondary,
  },
  accordionTitulo: {
    fontWeight: 600,
    fontSize: "0.95rem",
  },
  accordionCountChip: {
    height: 20,
    fontSize: "0.7rem",
    fontWeight: "bold",
    color: theme.palette.text.secondary,
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.black.lighter,
  },
  accordionDetails: {
    pt: 0,
  },
});
export default styles;
